import React from 'react';
import { Table } from 'semantic-ui-react';
import { number, arrayOf, object } from 'prop-types';

const WebProperties = props => (
  <Table celled>
    <Table.Header>
      <Table.Row>
        <Table.HeaderCell>Web Property</Table.HeaderCell>
        <Table.HeaderCell>Sessions</Table.HeaderCell>
        <Table.HeaderCell>Users</Table.HeaderCell>
      </Table.Row>
    </Table.Header>
    <Table.Body>
      {props.data.map(gaProp => (
        <Table.Row key={gaProp.name}>
          <Table.Cell>{gaProp.name}</Table.Cell>
          <Table.Cell>{Number(gaProp.sessions).toLocaleString()}</Table.Cell>
          <Table.Cell>{Number(gaProp.users).toLocaleString()}</Table.Cell>
        </Table.Row>
      ))}
      <Table.Row>
        <Table.Cell>Total</Table.Cell>
        <Table.Cell>{props.sessions.toLocaleString()}</Table.Cell>
        <Table.Cell>{props.users.toLocaleString()}</Table.Cell>
      </Table.Row>
    </Table.Body>
  </Table>
);

WebProperties.propTypes = {
  sessions: number.isRequired,
  users: number.isRequired,
  data: arrayOf(object.isRequired).isRequired,
};

export default WebProperties;



// WEBPACK FOOTER //
// ./src/components/WebPropertiesTable.jsx